import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './side-nav.component';
import { ContextButtonsComponent } from '../context-buttons/context-buttons.component';
import { MainToolbarComponent } from '../main-toolbar/main-toolbar.component';
import { OneTimeModule } from '../../common/directives/one-time/one-time.module';
import { SideMenuButtonModule } from '../side-menu-button/side-menu-button.module';
import { SearchBarModule } from '../../location/search-bar/search-bar.module';
import { LayoutRowModule } from '../../common/directives/layout-row/layout-row.module';
import { LayoutColumnModule } from '../../common/directives/layout-column/layout-column.module';
import { MainTitleModule } from '../main-title/main-title.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { OnceNgIfModule } from '../../common/directives/once-ng-if/once-ng-if.module';
import { BannerModule } from '../../common/components/banner/banner.module';
import { AngularResizedEventModule } from 'angular-resize-event';

@NgModule({
    declarations: [
        ContextButtonsComponent,
        SideNavComponent,
        MainToolbarComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        MatButtonModule,
        OneTimeModule,
        SideMenuButtonModule,
        SearchBarModule,
        LayoutRowModule,
        LayoutColumnModule,
        MainTitleModule,
        OnceNgIfModule,
        BannerModule,
        AngularResizedEventModule
    ],
    exports: [
        ContextButtonsComponent,
        SideNavComponent,
        MainToolbarComponent
    ]
})
export class SideNavModule {}
